import { ParseKeysByKeyPrefix, TFunction } from 'i18next'

import i18n from '@/i18n'

export type DeliveryStatusCodeKey = ParseKeysByKeyPrefix<'pkg', 'deliveryStatusCodes'>

const HTML_TAG_RE = /<[^>]*>/g

export type DeliveryStatusFields = {
  code?: string | null
  subCode?: string | null
  statusText?: string | null
}

export function getDeliveryStatusTranslationKey(
  code: string | null | undefined,
  subCode?: string | null,
  exists: (key: string) => boolean = key => i18n.exists(key)
): DeliveryStatusCodeKey | null {
  const trimmedCode = code?.trim()
  if (!trimmedCode) return null

  const trimmedSubCode = subCode?.trim()
  if (trimmedSubCode) {
    const specificKey = `pkg.deliveryStatusCodes.${trimmedCode}_${trimmedSubCode}`
    if (exists(specificKey)) {
      return specificKey as DeliveryStatusCodeKey
    }
  }

  const baseKey = `pkg.deliveryStatusCodes.${trimmedCode}`
  if (exists(baseKey)) {
    return baseKey as DeliveryStatusCodeKey
  }

  return null
}

function stripTranslationHtml(text: string): string {
  return text.replace(HTML_TAG_RE, '')
}

export function formatDeliveryStatusLabel(
  code: string | null | undefined,
  subCode?: string | null,
  options?: {
    fallback?: string | null
    includeCode?: boolean
    t?: TFunction
    exists?: (key: string) => boolean
  }
): string {
  const trimmedCode = code?.trim() ?? ''
  const trimmedSubCode = subCode?.trim() ?? ''
  const key = getDeliveryStatusTranslationKey(trimmedCode, trimmedSubCode, options?.exists)
  const translate = options?.t ?? i18n.t.bind(i18n)
  const translated = key ? stripTranslationHtml(String(translate(key))) : ''
  const label = translated || options?.fallback?.trim() || ''
  const codeDisplay = trimmedSubCode ? `${trimmedCode}_${trimmedSubCode}` : trimmedCode

  if (options?.includeCode && codeDisplay) {
    if (label && label !== codeDisplay) return `${label} (${codeDisplay})`
    return codeDisplay
  }

  return label || codeDisplay
}

export function resolveLatestDeliveryStatus(pkg: {
  exelotStatusCode?: string | null
  deliveryStatuses?: DeliveryStatusFields[] | null
}): DeliveryStatusFields {
  const latest = pkg.deliveryStatuses?.[0]
  return {
    code: latest?.code ?? pkg.exelotStatusCode,
    subCode: latest?.subCode,
    statusText: latest?.statusText,
  }
}
